import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './layout/Dashboard';
import SignIn from './pages/SignIn';
import RequesterPortal from './pages/requester/RequesterPortal';
import CsatFeedbackPage from './pages/CsatFeedbackPage';
import { applyAccentColor, applyFullTheme, DEFAULT_ACCENT } from './constants/theme';

function App() {
  const [token, setToken] = useState(() => localStorage.getItem('token') || null);
  const [currentUser, setCurrentUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('user')) || null; } catch { return null; }
  });

  // Apply saved full theme on every page load (including sign-in)
  useEffect(() => {
    const saved = localStorage.getItem('themeName') || 'default';
    if (saved !== 'default') {
      applyFullTheme(saved);
    } else {
      applyAccentColor(localStorage.getItem('accentColor') || DEFAULT_ACCENT);
    }
  }, []);

  const feedbackMatch = typeof window !== 'undefined'
    ? window.location.pathname.match(/^\/feedback\/([a-f0-9]+)$/i)
    : null;
  if (feedbackMatch) {
    return <CsatFeedbackPage token={feedbackMatch[1]} />;
  }

  const handleSignIn = (token, user) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
    setToken(token);
    setCurrentUser(user);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setToken(null);
    setCurrentUser(null);
  };

  if (!token) return <SignIn onSignIn={handleSignIn} />;

  // Requester role → dedicated self-service portal
  if (currentUser?.role === 'requester') {
    return (
      <>
        <RequesterPortal currentUser={currentUser} onLogout={handleLogout} />
      </>
    );
  }

  const defaultPath = '/dashboard';
  return (
    <Routes>
      <Route path="/" element={<Navigate to={defaultPath} replace />} />
      <Route path="/*" element={<Dashboard onLogout={handleLogout} currentUser={currentUser} />} />
    </Routes>
  );
}

export default App;